import $x from '@/utils/$x';

/**
 * 一周的报告数据
 * @param {*} params
 * @returns
 */
export function weeklyReportData(params) {
  return $x.post('/ptrainer/weeklyReportData', params);
}

/**
 * 用户完课统计数据
 * @param {*} params
 * @returns
 */
export function targetUserClassData(params) {
  return $x.post('/v1/litta/operation/data/userClassStatistic', params);
}
/**
 * AI会员统计数据
 * @param {*} params
 * @returns
 */
export function targetAiMemberData(params) {
  return $x.post('/v1/litta/operation/data/aiMemberStatisticData', params);
}
/**
 * 续费统计数据
 * @param {*} params
 * @returns
 */
export function targetAvaiableAiData(params) {
  return $x.post('/v1/litta/operation/data/renewStatisticData', params);
}
/**
 * AI会员/正式会员完课数统计数据
 * @param {*} params
 * @returns
 */
export function targetExperienceAiData(params) {
  return $x.post('/v1/litta/operation/data/memberClassStatisticData', params);
}
/**
 * 查询私域加微信息
 * @param {*} params
 * @returns
 */
export function targetPrivateDomainData(params) {
  return $x.post('v1/litta/operation/data/user/touch', params);
}
/**
 * 作业点评看板
 * @param {*} params
 * @returns
 */
export function homeworkBoardStatistics(params) {
  return $x.post('/actioncomment/statistics', params);
}

/**
 * 经营看板-订单数据
 * @param {*} params
 * @returns
 */
export function getOrderData(params) {
  return $x.post('/databoard/orderdata', params);
}

/**
 * 经营看板-自动续费签约
 * @param {*} params
 * @returns
 */
export function getRenewData(params) {
  return $x.post('/databoard/renewdata', params);
}

/**
 * 经营看板-AI课付费会员
 * @param {*} params
 * @returns
 */
export function getAiRightData(params) {
  return $x.post('/databoard/airightdata', params);
}

/**
 * 经营看板-完课数据
 * @param {*} params
 * @returns
 */
export function getCompleteClassData(params) {
  return $x.post('/databoard/completeclassdata', params);
}

/**
 * 作业点评看板-问题点列表
 * @param {*} params
 * @returns
 */
export function homeworkProblemSort(params) {
  return $x.post('/actioncomment/problemSort', params);
}

/**
 * 本地录制统计相关数据
 * @param {*} params
 * @returns
 */
export function getStatisticsRes(params) {
  return $x.post('/v1/litta/operation/data/getStatisticsRes', params);
}

/**
 * GMV趋势
 * @param {*} params
 * @returns
 */
export function gmvTrend(params) {
  return $x.post('/data/board/gmvTrend', params);
}

/**
 * GMV
 * @param {*} params
 * @returns
 */
export function gmv(params) {
  return $x.post('/data/board/gmv', params);
}

/**
 * SP GMV
 * @param {*} params
 * @returns
 */
export function spGmv(params) {
  return $x.post('/data/board/spGmv', params);
}

/**
 * 订单数据
 * @param {*} params
 * @returns
 */
export function getGmvOrderData(params) {
  return $x.post('/data/board/payOrderData', params);
}
/**
 * 订单数据
 * @param {*} params
 * @returns
 */
export function getPayUserData(params) {
  return $x.post('/data/board/payUserData', params);
}

// /**
//  * 会员用户趋势
//  * @param {*} params
//  * @returns
//  */
// export function vipUserTrend(params) {
//   return $x.post('/data/board/vipUserTrend', params);
// }

// /**
//  * 399会员
//  * @param {*} params
//  * @returns
//  */
// export function v399(params) {
//   return $x.post('/data/board/v399', params);
// }

// /**
//  * v199
//  * @param {*} params
//  * @returns
//  */
// export function v199(params) {
//   return $x.post('/data/board/v199', params);
// }

// /**
//  * 0元体验
//  * @param {*} params
//  * @returns
//  */
// export function exp0(params) {
//   return $x.post('/data/board/exp0', params);
// }

// /**
//  * 9.9元体验 ID：VzNON7x2
//  * @param {*} params
//  * @returns
//  */
// export function v99(params) {
//   return $x.post('/data/board/v99', params);
// }

// /**
//  * 家庭网数据情况
//  * @param {*} params
//  * @returns
//  */
// export function getFamilyData(params) {
//   return $x.post('/data/board/familyData', params);
// }

// /**
//  * 周期性约课开通情况
//  * @param {*} params
//  * @returns
//  */
// export function periodicityPointClass(params) {
//   return $x.post('/data/board/periodicityPointClass', params);
// }

// /**
//  * 199会员导出
//  * @param {*} params
//  * @returns
//  */
// export function v199Export(params) {
//   return $x.post('/data/board/v199Export', params);
// }

// /**
//  * 399会员导出
//  * @param {*} params
//  * @returns
//  */
// export function v399Export(params) {
//   return $x.post('/data/board/v399Export', params);
// }

// /**
//  * 9.9会员导出
//  * @param {*} params
//  * @returns
//  */
// export function v99Export(params) {
//   return $x.post('/data/board/v99Export', params);
// }

/**
 * 私教付费会员概览
 * @param {*} params
 * @returns
 */
export function ptPaidUser(params) {
  return $x.post('v1/litta/operation/data/ptPaidUser', params);
}
/**
 * 私教付费会员概览
 * @param {*} params
 * @returns
 */
export function ptPaidUserFunnel(params) {
  return $x.post('v1/litta/operation/data/ptPaidUserFunnel', params);
}
/**
 * 导出
 * @param {*} params
 * @returns
 */
export function importPtPaidUser(params) {
  return $x.post('v1/litta/operation/data/importPtPaidUser', params);
}
/**
 * GMV分类
 * @param {*} params
 * @returns
 */
export function gmvClassification(params) {
  return $x.post('/data/board/gmvClassification', params);
}
/**
 * GMV趋势 ID：Q2Vk5xx8
 * @param {*} params
 * @returns
 */
export function gmvTrendSBC(params) {
  return $x.post('/data/board/gmvTrendSBC', params);
}
/**
 * GMV分类 ID：kXOOxN5X
 * @param {*} params
 * @returns
 */
export function gmvClassificationSBC(params) {
  return $x.post('/data/board/gmvClassificationSBC', params);
}
/**
 * 教练多端登录情况
 */
export function coachMultiClientLoginData(params) {
  return $x.post('/tenant/statistic/coachMultiClientLoginData', params);
}
/**
 * 查询注册教练每日趋势
 */
export function registCoachTrend(params) {
  return $x.post('/tenant/statistic/registCoachTrend', params);
}
/**
 * 导出注册教练每日趋势
 */
export function registerCoachImport(params) {
  return $x.post('/tenant/statistic/registerCoachImport', params);
}
/**
 * 查询下挂会员每日趋势
 */
export function liteTrend(params) {
  return $x.post('/tenant/statistic/liteTrend', params);
}
/**
 * 导出下挂会员每日趋势
 */
export function liteUserImport(params) {
  return $x.post('/tenant/statistic/liteUserImport', params);
}
/**
 * 整体概览
 */
export function tenantDataOverview(params) {
  return $x.post('/tenant/statistic/tenantDataOverview', params);
}
/**
 * 商家教练漏斗
 */
export function coachFunnel(params) {
  return $x.post('/tenant/statistic/coachFunnel', params);
}
/**
 * 下挂会员漏斗
 */
export function tenantMemberFunnel(params) {
  return $x.post('/tenant/statistic/tenantMemberFunnel', params);
}
/**
 * 查询所有可用的时间范围
 */
export function listAvailablePeriodTypes(params) {
  return $x.get('/v1/litta/operation/data/listAvailablePeriodTypes', params);
}
/**
 * LITTA健身课数据指标查询
 */
export function queryLittaUserIndicators(params) {
  return $x.post('/v1/litta/operation/data/queryLittaUserIndicators', params);
}
/**
 * LITTA健身课新用户漏斗查询
 */
export function queryLittaUserFunnel(params) {
  return $x.post('/v1/litta/operation/data/queryLittaUserFunnel', params);
}
/**
 * GMV日常统计
 */
export function gmvIndicator(params) {
  return $x.post('/v1/litta/daily/data/gmvIndicator', params);
}
/**
 * 资金账户日常统计
 */
export function fundIndicator(params) {
  return $x.post('/v1/litta/daily/data/fundIndicator', params);
}
/**
 * 订单数日常统计
 */
export function orderCountIndicator(params) {
  return $x.post('/v1/litta/daily/data/orderCountIndicator', params);
}
/**
 * 商家日常统计
 */
export function merchantIndicator(params) {
  return $x.post('/v1/litta/daily/data/merchantIndicator', params);
}
/**
 * 会员日常统计
 */
export function memberIndicator(params) {
  return $x.post('/v1/litta/daily/data/memberIndicator', params);
}
/**
 * 会员日常统计
 */
export function classCountIndicator(params) {
  return $x.post('/v1/litta/daily/data/classCountIndicator', params);
}
/**
 * 渠道
 */
export function getOrderChannelStatistic(params) {
  return $x.post('/v1/litta/daily/data/getOrderChannelStatistic', params);
}
/**
 * 退款
 */
export function getOrderRefundStatistic(params) {
  return $x.post('/v1/litta/daily/data/getOrderRefundStatistic', params);
}
/**
 * 商家分页数据
 */
export function pageMerchantIndicatorDetail(params) {
  return $x.post('/v1/litta/daily/data/merchantIndicatorDetail', params);
}
/**
 * 会员完课数日常统计
 */
export function memberTrainingOverviewIndicator(params) {
  return $x.post(
    '/v1/litta/daily/data/memberTrainingOverviewIndicator',
    params,
  );
}
/**
 * 会员完课趋势日常统计
 */
export function memberTrainingTrendIndicator(params) {
  return $x.post('/v1/litta/daily/data/memberTrainingTrendIndicator', params);
}
/**
 * 看得见活动-数据概览
 */
export function queryViewActivityData(params) {
  return $x.post('/v1/litta/operation/data/queryViewActivityData', params);
}
/**
 * 看得见活动-数据课程数据
 */
export function queryViewActivityClassData(params) {
  return $x.post('/v1/litta/operation/data/queryViewActivityClassData', params);
}
/**
 * 看得见活动-完课用户数据
 */
export function queryViewActivityUserCompleteData(params) {
  return $x.post(
    '/v1/litta/operation/data/queryViewActivityUserCompleteData',
    params,
  );
}
/**
 * 导出
 * @param {*} params
 * @returns
 */
export function exportUserClassInViewActivity(params) {
  return $x.post(
    'v1/litta/operation/data/exportUserClassInViewActivity',
    params,
  );
}
/**
 * 私教会员
 */
export function queryPtMember(params) {
  return $x.post('/v1/litta/operation/data/ptMember', params);
}
/**
 * 在期私教会员行为数据 ID：VXEboqoz
 */
export function queryBehaviorData(params) {
  return $x.post('/v1/litta/operation/data/behaviorData', params);
}
